import { render } from "./ClassMomCard.vue?vue&type=template&id=1eb233f8&scoped=true"
import script from "./ClassMomCard.vue?vue&type=script&lang=js"
export * from "./ClassMomCard.vue?vue&type=script&lang=js"

import "./ClassMomCard.vue?vue&type=style&index=0&id=1eb233f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb233f8"]])

export default __exports__